import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
export var DOWNLOAD_VARIANT = {
  // The edited source file (LaTeX .tex or the tracked-changes Word file)
  EDITED: 'edited',
  // The LaTeX PDF with tracked changes
  PDF: 'pdf',
  // The clean (no tracked changes) Word file
  CLEAN: 'clean'
};
var RubriqDownloadButton = function RubriqDownloadButton(_ref) {
  var completed = _ref.completed,
    downloading = _ref.downloading,
    isLatex = _ref.isLatex,
    isWord = _ref.isWord,
    isEditing = _ref.isEditing,
    isTranslation = _ref.isTranslation,
    isPdfFailed = _ref.isPdfFailed,
    hasCleanDeliverable = _ref.hasCleanDeliverable,
    onDownload = _ref.onDownload,
    onLatexMenuOpened = _ref.onLatexMenuOpened;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;

  // Editing shows two variants (LaTeX: .tex + PDF; Word: clean + tracked changes),
  // rendered as a labelled "Download" button with a dropdown. Word only offers two
  // options when a clean deliverable exists; otherwise it falls back to a single
  // (labelled) download button.
  var showWordOptions = isWord && hasCleanDeliverable;
  var showDropdown = isEditing && (isLatex || showWordOptions);

  // Editing and Translation render the labelled green "Download" button; any other
  // workspace keeps the compact ghost icon with no label.
  var labelled = isEditing || isTranslation;
  var spinnerOrIcon = downloading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-arrow-down",
    "data-testid": "rubriq-download-file"
  });

  // Plain single-button download when there is only one deliverable to offer.
  if (!showDropdown) {
    return /*#__PURE__*/React.createElement(Popover, {
      content: "curie.download-file",
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "bottom"
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": t('curie.download-file'),
      type: "button",
      className: labelled ? 'not-global btn btn-primary rounded-3 text-nowrap d-flex align-items-center pe-1' : 'not-global btn btn-primary rubriq-ghost-button',
      onClick: function onClick() {
        return onDownload(DOWNLOAD_VARIANT.EDITED);
      },
      disabled: !completed || downloading
    }, /*#__PURE__*/React.createElement("span", {
      className: "me-2"
    }, spinnerOrIcon), /*#__PURE__*/React.createElement(T, {
      source: downloading ? 'Downloading...' : labelled && 'Download' || ''
    }), labelled && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-caret-down",
      className: "ms-1 me-1",
      style: {
        visibility: 'hidden'
      }
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown rubriq-dropdown d-inline-block"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary rounded-3 text-nowrap d-flex align-items-center pe-1",
    "data-bs-toggle": "dropdown",
    "aria-label": t('curie.download-file'),
    disabled: !completed || downloading,
    onClick: isLatex ? onLatexMenuOpened : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "me-2"
  }, spinnerOrIcon), /*#__PURE__*/React.createElement(T, {
    source: downloading ? 'Downloading...' : 'Download'
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-down",
    className: "ms-1 me-1"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu overflow-visible p-0"
  }, isLatex ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return onDownload(DOWNLOAD_VARIANT.EDITED);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "Edited LaTeX file (.tex)"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return !isPdfFailed && onDownload(DOWNLOAD_VARIANT.PDF);
    },
    disabled: isPdfFailed
  }, /*#__PURE__*/React.createElement("span", {
    className: isPdfFailed ? 'text-muted' : ''
  }, /*#__PURE__*/React.createElement(T, {
    source: "PDF with tracked changes"
  })), isPdfFailed && /*#__PURE__*/React.createElement(Popover, {
    content: t('unknown-error-editing-card-title'),
    className: "pe-auto",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "right"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info",
    className: "text-danger ms-2"
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return onDownload(DOWNLOAD_VARIANT.CLEAN);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.edited-doc-file"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item fw-normal py-2 px-3 rubriq-dropdown-item",
    onClick: function onClick() {
      return onDownload(DOWNLOAD_VARIANT.EDITED);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.edited-doc-file-tracked-changes"
  }))))));
};
export default RubriqDownloadButton;